var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodbeverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19H28C28 17.3437 26.3211 16 24.2404 16H15.7596C13.6839 16 12 17.3437 12 19Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7589 28H24.242C26.317 28 28.0004 26.2138 28.0004 24H12.0004C12.0004 26.2084 13.6838 28 15.7589 28Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7231 20H13.2778C12.571 20 12.0004 20.67 12.0004 21.5C12.0004 22.33 12.571 23 13.2778 23H26.7231C27.4299 23 28.0004 22.33 28.0004 21.5C28.0004 20.67 27.4299 20 26.7231 20Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7214 4H5.29419L4.00043 7H22.0004L20.7214 4Z",
    fill: "#00ADEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3956 23.4263H12.6562C11.8853 23.0843 11.3568 22.3269 11.3568 21.4131C11.3568 20.4652 11.958 19.6443 12.8065 19.3413H11.3907V18.3738C11.3907 15.8475 13.4938 15 16.0004 15H20.3992L21.0004 8H5.00043L7.09012 28H13.141C10.8865 26.2018 11.3956 23.4263 11.3956 23.4263Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodbeverage);
export default __webpack_public_path__ + "static/media/food&beverage.b401b9a1e70773b9dfa65bef7544be5c.svg";
export { ForwardRef as ReactComponent };